<template>
  <section id="thanksPaypal">
    <div class="ps card border border-success" v-if="validate">
      <div class="ps-header">
        <div class="ps-reminder bg-dark">Ficha digital. No es necesario imprimir.</div>
        <div class="ps-reference pt-5 pb-2">
          <h3 class="pb-4 text-success">FELICIDADES !!!</h3>
           <div class="check-wrap"></div>
          <p>Tu pedido quedó registrado con el número de orden: 
              <strong> {{ order }}.</strong>
          </p>
          <p>Tu suscripcion se renovara automaticamente.</p>
        </div>
      </div>
      <div class="ps-instructions">
        <div class="ps-footnote">
          Pronto recibirás un correo de <strong>MMK Group</strong> confirmando
          tu pago.
        </div>
      </div>
    </div>
    <div class="emptyHtml" v-else>
	</div>
  </section>
</template>

<script>
// @ is an alias to /src
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const axios = require("axios");

export default {
    name: "thanksPaypal",
    data() {
        return {
          api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
          paypal_client_id: process.env.VUE_APP_PAYPAL_SANDBOX_APP_CLIENT_ID,
          paypal_secret_id: process.env.VUE_APP_PAYPAL_SANDBOX_APP_SECRET_ID,
          url_paypal:"https://api-m.sandbox.paypal.com/v1/oauth2/token",
          is_loading:true,
          token: null,
          order: null,
          validate: false
        };
    },
    components: {
      Loading
    },
    mounted() {
        // Inicia la pagina arriba
        $(window).scrollTop(0);
        // Verifica la URL
        var hash = document.location.href.toString().split('?')[1];
        var result = hash.split('&').reduce(function (res, item) {
            var parts = item.split('=');
            res[parts[0]] = parts[1];
            return res;
        }, {})

        this.token = result.token;
        this.order = result.order;

        this.successPaypal(this.token, this.order);
        
    },
    methods:{
    successPaypal: function(token, order){
      console.log('paypal/subscription-success');
      axios({
        method: "POST",
        url: this.api_url + "/paypal/subscription-success",
        data: {
          order: order,
          token: token
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      })
      .then((response) => {
          if (response.status) {

            if(localStorage.getItem('productWaiting')){
              window.dataLayer.push({
                'event': 'suscripcionComprada',
                'pageURL': this.$router.currentRoute.fullPath,
                'subscription': localStorage.getItem('productWaiting'),
                'dateOfPurchase': new Date().toLocaleString('en-US')
              });
              this.$store.commit("finishProduct");
            }
            else{
              window.dataLayer.push({
                'event': 'suscripcionComprada',
                'pageURL': this.$router.currentRoute.fullPath,
                'subscription': this.$route.params.products,
                'dateOfPurchase': new Date().toLocaleString('en-US')
              });
            }

            console.info('Success subscription');
            console.info(response);
            this.validate= true;
            this.$store.commit('finishStoreSubscription');
          } else {
            this.$snotify.error("error");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    }
};
</script>

<style lang="scss" scoped>
#thanksPaypal .emptyHtml{
	min-height: 50vh;
	opacity:0;
}

#thanksPaypal .ps {
	margin:8% auto;
}
#thanksPaypal .check-wrap {
	width: 70px;
	height: 70px;
	border-radius: 50%;
	border: 2px solid #28a745;
	position: relative;
	overflow: hidden;
	animation: wrap 0.3s ease-in-out forwards;
	animation-delay: 0.3s;
	transform: scale(0);
	margin:auto;
}
#thanksPaypal .check-wrap::before, .check-wrap::after {
	content: "";
	position: absolute;
	background-color: white;
	width: 0;
	height: 5px;
	transform-origin: left;
	animation-duration: 0.3s;
	animation-timing-function: ease-in-out;
	animation-fill-mode: forwards;
	animation-iteration-count: 2;
}
#thanksPaypal .check-wrap::before {
	top: 32px;
	left: 21px;
	transform: rotate(45deg);
	animation-name: left;
	animation-delay: 0.8s;
}
#thanksPaypal .check-wrap::after {
	top: 42px;
	left: 29px;
	transform: rotate(-45deg);
	animation-name: right;
	animation-delay: 1.1s;
}

@keyframes wrap {
  0% {
    background-color: transparent;
    transform: scale(0);
  }
  100% {
    background-color: #28a745;
    transform: scale(1);
  }
}
@keyframes left {
  0% {
    width: 0;
  }
  100% {
    width: 15px;
  }
}
@keyframes right {
  0% {
    width: 0;
  }
  100% {
    width: 30px;
  }
}
li{
	padding: 1% 0;
}

@media (max-width: 576px) {
	#thanksPaypal .ps {
    	max-width: 496px;
		width:100%;
	}
	#thanksPaypal .ps-brand img {
		max-width: 120px;
	}
	#thanksPaypal h3{
		font-size:2rem;
	}
	#thanksPaypal .ps-instructions {
    	padding: 32px 20px 45px;
	}
	#thanksPaypal .ps-reference h1{
		font-size: 1.3rem;
	}
}
</style>
